import { Autocomplete } from "@react-google-maps/api";
import { useRef } from "react";
import Input from "./Input";
import { useLoadScript } from "@react-google-maps/api";

const libraries = ["places", "maps", "marker"];

const AddressInput = ({ formData, setFormData, errors, setErrors, which }) => {
  const autocompleteRef = useRef(null);

  const handlePlaceChanged = () => {
    const place = autocompleteRef.current.getPlace();
    if (which) {
      setFormData({ ...formData, address: place.formatted_address || "" });
      setErrors({ ...errors, address: "" });
    } else {
      setFormData({
        ...formData,
        businessAddress: place.formatted_address || "",
      });
      setErrors({ ...errors, businessAddress: "" });
    }
  };

  return (
    <Autocomplete
      onLoad={(auto) => (autocompleteRef.current = auto)}
      onPlaceChanged={handlePlaceChanged}
    >
      <Input
        float={true}
        label={which ? "Enter  Address" : "Business Address*"}
        placeholder="Enter address here"
        className="mt-6"
        value={which ? formData.address : formData.businessAddress}
        onChange={(e) => {
          if (which) {
            setFormData({ ...formData, address: e.target.value });
            setErrors({ ...errors, address: "" });
          } else {
            setFormData({ ...formData, businessAddress: e.target.value });
            setErrors({ ...errors, businessAddress: "" });
          }
        }}
        error={which ? errors.address : errors.businessAddress}
      />
    </Autocomplete>
  );
};

const GoogleMapsWrapper = ({
  errors,
  setErrors,
  formData,
  setFormData,
  which,
}) => {
  const { isLoaded, loadError } = useLoadScript({
    googleMapsApiKey: "AIzaSyD-4Q_BPIHXnGv1dqlaLOBKMM3mZRrPy4E",
    libraries,
  });

  if (loadError) {
    console.error("Error loading Google Maps script:", loadError);
    return null;
  }

  if (!isLoaded) return null;

  return (
    <AddressInput
      errors={errors}
      setErrors={setErrors}
      formData={formData}
      setFormData={setFormData}
      which={which}
    />
  );
};

export default GoogleMapsWrapper;
